<template>
  <div class="alert alert-info" role="alert">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="alert-heading">{{ $t('topbanner.preview.header') }}</h4>
            <button
              type="button"
              class="btn-close btn-info"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <p class="mt-4">
            {{ $t('topbanner.preview.body') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBanner',
  props: {
    surveyName: {
      type: String
    }
  }
}
</script>

<style scopes>
.alert {
  /* remove border radius and left/right borders */
  border-radius: 0;
  border-left: 0;
  border-right: 0;
}
</style>
